module.exports = __webpack_public_path__ + "dingbeauty-landing/img/plan02@2.24580acc.jpg";